import { useTranslation } from 'next-i18next';
import styled from 'styled-components';
import { ErrorMessage } from '@storefront/lib-global/baseComponents/errors';
import { TypographyStyles, media, spacing } from '@storefront/lib-global/stylings';
import { useOccasionAndDenominationContext } from '../../context/occasionAndDenominationContext';
import { MeasurementBlock, MeasurementList, MeasurementListItem } from './MeasurementBlock/MeasurementBlock';

const S = {
  Container: styled.div`
    > ul {
      display: grid;
      grid-template-columns: repeat(3, 1fr);
    }

    button:disabled {
      cursor: unset;
    }

    @media ${media.greaterThan('lg')} {
      > ul {
        grid-template-columns: repeat(5, 1fr);
      }
    }
  `,

  Title: styled.h2`
    ${TypographyStyles.Headings.H5}
    margin: 0 0 ${spacing.XXXS};

    @media ${media.greaterThan('lg')} {
      margin: 0 0 ${spacing.XXS};
    }
  `,
};

export function PriceDenominations() {
  const { t } = useTranslation(['lib-products-common']);
  const {
    uniquePriceDenominations,
    selectedPriceDenomination,
    selectedOccasionVariant,
    handleChangePriceDenomination,
    priceDenominationError,
  } = useOccasionAndDenominationContext();

  if (uniquePriceDenominations.length === 0) return null;

  return (
    <S.Container>
      <S.Title>{t('pdp.giftcard.select.amount')}</S.Title>
      <MeasurementList id="price-denominations">
        {uniquePriceDenominations.map(({ priceDenomination }) => (
          <MeasurementListItem key={priceDenomination}>
            <MeasurementBlock
              type="button"
              onClick={() =>
                handleChangePriceDenomination(priceDenomination, selectedOccasionVariant.occasion as string)
              }
              className={selectedPriceDenomination === priceDenomination ? 'active' : ''}
              disabled={selectedPriceDenomination === priceDenomination}
            >
              {priceDenomination}
            </MeasurementBlock>
          </MeasurementListItem>
        ))}
      </MeasurementList>
      {priceDenominationError ? (
        <ErrorMessage data-testid="giftAmountSelectError">{t('pdp.giftcard.price.error')}</ErrorMessage>
      ) : null}
    </S.Container>
  );
}

export default PriceDenominations;
